import { LINE_STATUSES } from '../firebase/schema';

export function isSampleOrder(orderOrInstructions) {
  if (!orderOrInstructions) return false;
  if (orderOrInstructions.sample === true) return true;
  const instructions = orderOrInstructions.additionalInstructions;
  return instructions?.sample === true;
}

export function isSampleLine(line, order) {
  if (line?.sampleLine === true) return true;
  if (line?.orderSample === true) return true;
  return isSampleOrder(order);
}

/** Skip screen cut and print queues; line still orders and receives normally. */
export function sampleLineProductionSkipFields() {
  return {
    isCut: true,
    printed: true,
    sampleLine: true
  };
}

/** Applied when a sample line is received (IN). */
export function sampleLineReceiveFields() {
  return {
    ...sampleLineProductionSkipFields(),
    status: LINE_STATUSES.COMPLETED,
    isIn: true
  };
}

export function lineStatusForNewOrder({ isDesignOnly, isSample, providedGoods }) {
  if (isDesignOnly) return LINE_STATUSES.COMPLETED;
  if (providedGoods) return LINE_STATUSES.ORDERED;
  return LINE_STATUSES.NEW;
}

export function lineExtrasForNewOrder({ isDesignOnly, isSample, providedGoods }) {
  if (isDesignOnly) {
    return { printed: true, ...(providedGoods && { orderedAt: new Date() }) };
  }
  if (isSample) {
    return { ...sampleLineProductionSkipFields() };
  }
  if (providedGoods) {
    return { orderedAt: new Date() };
  }
  return {};
}
